import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ICourseSession } from "src/app/attendanceRecord/interfaces/SessionsInterface";
import { ICatalogItem } from "src/app/catalog/interfaces/catalog.interface";

@Component({
  selector: "app-year-session-selector",
  templateUrl: "./year-session-selector.component.html",
  styleUrls: ["./year-session-selector.component.css"],
})
export class YearSessionSelectorComponent {
  @Input() yearList: ICatalogItem[] = [];
  @Input() sessions: ICourseSession[] = [];

  @Input() selectedYear: number | null = null;
  @Input() selectedSessionId: number | null = null;

  @Input() isLoadingSessions: boolean = false;
  @Input() showSessionError: boolean = false;
  @Input() disabled: boolean = false;

  @Output() yearChange = new EventEmitter<number>();
  @Output() sessionChange = new EventEmitter<number | null>();
  @Output() sessionBlur = new EventEmitter<void>();

  onYearChange(value: number): void {
    this.selectedYear = value;
    this.selectedSessionId = null;

    this.yearChange.emit(value);
    this.sessionChange.emit(null);
  }

  onSessionChange(value: number | null): void {
    this.selectedSessionId = value;
    this.sessionChange.emit(value);
  }

  onSessionBlur(): void {
    this.sessionBlur.emit();
  }
}
